import * as R from 'ramda';

export const capitalize = (str: string): string =>
  str.length === 0 ? '' : str.charAt(0).toUpperCase() + str.slice(1);

export const toTitleCase = R.compose(
  R.join(' '),
  R.map(capitalize),
  R.split(' '),
  R.toLower,
);

export const capitalSnakeCaseToTitleCase = (str: string) => {
  const words = str.split('_');
  return words.map(toTitleCase).join(' ');
};

export const pluralize = (count, label) =>
  `${label}${count > 1 || count === 0 ? 's' : ''}`;

export const maskUntilPos = (str: string, pos: number = 3): string => {
  const keepChars = str.slice(-pos);
  if (str.length <= pos) {
    return keepChars;
  }
  return ['*'.repeat(str.length - pos), keepChars].join('');
};

export const stripWhiteSpace = (str: string): string => str.replace(/\s+/g, '');

export const csvEscape = (value: string): string => {
  const str = value.trim();

  if (str.includes(',') || str.includes('"') || str.includes('\n')) {
    return `"${str.replace(/"/g, '""')}"`;
  }

  return str;
};
